import { render } from "./TCMathGamePage.vue?vue&type=template&id=10441859&scoped=true"
import script from "./TCMathGamePage.vue?vue&type=script&lang=js"
export * from "./TCMathGamePage.vue?vue&type=script&lang=js"

import "./TCMathGamePage.vue?vue&type=style&index=0&id=10441859&lang=css"
import "./TCMathGamePage.vue?vue&type=style&index=1&id=10441859&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tunescrib-rs/tunescrib-rs/dev.tunescrib.com-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10441859"]])

export default __exports__